module.exports = __webpack_public_path__ + "img/9ne.833d5022.svg";